import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-expansion-panel',
  templateUrl: './expansion-panel.component.html',
  styleUrls: ['./expansion-panel.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ExpansionPanelComponent {
  @Input() expanded = false;
  @Output() closed = new EventEmitter();
  @Output() opened = new EventEmitter();

  constructor() {}

  toggle() {
    this.expanded = !this.expanded;

    if (this.expanded) {
      this.opened.emit();
    } else {
      this.closed.emit();
    }
  }
}
